/*!

=========================================================
* Material Dashboard PRO React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import {
  blackColor,
  dangerCardHeader,
  hexToRgb,
  infoCardHeader,
  primaryCardHeader,
  roseCardHeader,
  successCardHeader,
  warningCardHeader,
  whiteColor,
} from "../../material-dashboard-pro-react.jsx";
const cardHeaderStyle = (_theme, _params, classes) => ({
  cardHeader: {
    padding: "0.75rem 1.25rem",
    marginBottom: "0",
    borderBottom: "none",
    background: "transparent",
    [`&.${classes.cardHeaderPlain},&.${classes.cardHeaderImage},&.${classes.cardHeaderContact},&.${classes.cardHeaderSignup},&.${classes.cardHeaderIcon},&.${classes.cardHeaderStats},&.${classes.warningCardHeader},&.${classes.successCardHeader},&.${classes.dangerCardHeader},&.${classes.infoCardHeader},&.${classes.primaryCardHeader},&.${classes.roseCardHeader}`]:
      {
        margin: "0 15px",
        padding: "0",
        position: "relative",
        color: whiteColor,
      },
    "&:first-child": {
      borderRadius: "calc(.25rem - 1px) calc(.25rem - 1px) 0 0",
    },
    [`&.${classes.warningCardHeader},&.${classes.successCardHeader},&.${classes.dangerCardHeader},&.${classes.infoCardHeader},&.${classes.primaryCardHeader},&.${classes.roseCardHeader}`]:
      {
        [`&:not(.${classes.cardHeaderIcon}):not(.${classes.cardHeaderImage}):not(.${classes.cardHeaderText})`]:
          {
            borderRadius: "3px",
            marginTop: "-20px",
            padding: "15px",
          },
      },
    [`&.${classes.cardHeaderStats} svg`]: {
      fontSize: "36px",
      lineHeight: "56px",
      textAlign: "center",
      width: "36px",
      height: "36px",
      margin: "10px 10px 4px",
    },
    [`&.${classes.cardHeaderStats} .fab,&.${classes.cardHeaderStats} .fas,&.${classes.cardHeaderStats} .far,&.${classes.cardHeaderStats} .fal,&.${classes.cardHeaderStats} .material-icons`]:
      {
        fontSize: "36px",
        lineHeight: "56px",
        width: "56px",
        height: "56px",
        textAlign: "center",
        overflow: "unset",
        marginBottom: "1px",
      },
    [`&.${classes.cardHeaderStats}.${classes.cardHeaderIcon}`]: {
      textAlign: "right",
    },
    [`&.${classes.cardHeaderImage}`]: {
      marginLeft: "15px",
      marginRight: "15px",
      marginTop: "-30px",
      borderRadius: "6px",
    },
    [`&.${classes.cardHeaderText}`]: {
      display: "inline-block",
    },
  },
  cardHeaderPlain: {
    marginLeft: "0px",
    marginRight: "0px",
    [`&.${classes.cardHeaderImage}`]: {
      margin: "0 !important",
    },
  },
  cardHeaderImage: {
    position: "relative",
    padding: "0",
    zIndex: "1",
    "& img": {
      width: "100%",
      borderRadius: "6px",
      pointerEvents: "none",
      boxShadow:
        "0 5px 15px -8px rgba(" +
        hexToRgb(blackColor) +
        ", 0.24), 0 8px 10px -5px rgba(" +
        hexToRgb(blackColor) +
        ", 0.2)",
    },
    "& a": {
      display: "block",
    },
  },
  cardHeaderContact: {
    margin: "0 15px",
    marginTop: "-20px",
  },
  cardHeaderSignup: {
    marginLeft: "20px",
    marginRight: "20px",
    marginTop: "-40px",
    padding: "20px 0",
    width: "100%",
    marginBottom: "15px",
  },
  cardHeaderStats: {
    [`& .${classes.cardHeaderIcon}`]: {
      textAlign: "right",
    },
    "& h1,& h2,& h3,& h4,& h5,& h6": {
      margin: "0 !important",
    },
  },
  cardHeaderIcon: {
    [`&.${classes.warningCardHeader},&.${classes.successCardHeader},&.${classes.dangerCardHeader},&.${classes.infoCardHeader},&.${classes.primaryCardHeader},&.${classes.roseCardHeader}`]:
      {
        background: "transparent",
        boxShadow: "none",
      },
    "& .fab,& .fas,& .far,& .fal,& .material-icons": {
      width: "33px",
      height: "33px",
      textAlign: "center",
      lineHeight: "33px",
    },
    "& svg": {
      width: "24px",
      height: "24px",
      textAlign: "center",
      lineHeight: "33px",
      margin: "5px 4px 0px",
    },
  },
  cardHeaderText: {},
  warningCardHeader: {
    color: whiteColor,
    [`&:not(.${classes.cardHeaderText}):not(.${classes.cardHeaderIcon})`]: {
      ...warningCardHeader,
    },
  },
  successCardHeader: {
    color: whiteColor,
    [`&:not(.${classes.cardHeaderText}):not(.${classes.cardHeaderIcon})`]: {
      ...successCardHeader,
    },
  },
  dangerCardHeader: {
    color: whiteColor,
    [`&:not(.${classes.cardHeaderText}):not(.${classes.cardHeaderIcon})`]: {
      ...dangerCardHeader,
    },
  },
  infoCardHeader: {
    color: whiteColor,
    [`&:not(.${classes.cardHeaderText}):not(.${classes.cardHeaderIcon})`]: {
      ...infoCardHeader,
    },
  },
  primaryCardHeader: {
    color: whiteColor,
    [`&:not(.${classes.cardHeaderText}):not(.${classes.cardHeaderIcon})`]: {
      ...primaryCardHeader,
    },
  },
  roseCardHeader: {
    color: whiteColor,
    [`&:not(.${classes.cardHeaderText}):not(.${classes.cardHeaderIcon})`]: {
      ...roseCardHeader,
    },
  },
});

export default cardHeaderStyle;
